<template>
  <div>
    <nav-breadcrumb :menu="[{label: '转账还款确认'}]"/>
    <el-row>
      <el-col class=" bg-purple">
        <el-tabs v-model="bankStatus">
          <el-tab-pane label="未确认" name="Processing" />
          <el-tab-pane label="已确认" name="Settled" />
        </el-tabs>
        <div>
          <div class="xzpadd10 of">
            <data-table
              :table-data="tableData"
              :columns="columns"
              :page.sync="page"
              :pageSize.sync="pageSize"
              :filters.sync="filters"
              :actions="actions"
              :is-multiple-selection-show="true"
              @handleSelectionChange="handleSelectChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="回单信息"
      :visible.sync="dialogVisible"
      width="30%">
      <form-build :form-data="bankDetail" :form-columns="bankColumns"></form-build>
    </el-dialog>
    <el-dialog
      title="备注编辑"
      :visible.sync="dialogVisible4"
      width="30%">

      <el-input type="textarea" v-model="remarks" ></el-input><br/><br/>
      <el-button @click="updateApproveRepayment()">保存</el-button>
    </el-dialog>

    <el-dialog
      title="选择匹配"
      :visible.sync="dialogVisible3"
      width="100%">
      <data-table
        :table-data="tableDataMatching"
        :columns="columnsMatching"
        :page.sync="pageMatching"
        :pageSize.sync="pageSizeMatching"
        :filters.sync="filtersMatching"
        :actions="actionsMatching"
      />
    </el-dialog>
    <el-dialog :visible.sync="repayForApprovalDialogVisible" title="还款申请" @close="dataRelaod()">
      <repay-for-approval :financing-detail="repayInfo" :transfer-repayment-detail="repayInfo" :repay-plan-list="repayInfo.detail"  @close="repayForApprovalDialogVisible=false" @ok="handleRepayForApproval"></repay-for-approval>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisible5"
      width="40%" @close="dataRelaod()">
      本次匹配本期（{{repayDate}}）还款后，余额为{{balanceAmount}},此客户还有其他贷款尚未结清，<br/>
      您可以选择<span class="color-danger">还完本笔贷款按期需要还的期数后余额</span>的处理方式：<br/>
      <el-radio v-model="radio" label="Y">不使用余额还其他贷款</el-radio><br/>
       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <el-radio v-if="showSelect" v-model="radioType" label="None">宕帐</el-radio>
        <el-radio v-if="showSelect" v-model="radioType" label="Profit">转入营业外收入</el-radio>
        <el-radio v-if="showSelect" v-model="radioType" label="Refund">返还客户</el-radio>
        <el-radio v-if="showSelect" v-model="radioType" label="Refund-ToDealer">返还渠道商</el-radio><br/>
      <el-radio v-model="radio" label="N">若要将余额用于还其他贷款，请先手动拆分银行流水。</el-radio><br/><br/>
      <el-button @click="updateApproveSelect()">保存</el-button>
    </el-dialog>

    <el-dialog
      title="拆分流水"
      :visible.sync="dialogVisible6"
      width="30%">
      原流水号：{{splittableData.de__bankRef}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      转账金额：{{splittableData.de__creditAmount|formatMoney}}

      <data-table
        :table-data="{data:this.splittableData.detail}"
        :columns="splittableDatacolumns"
        :actions="[]"
        :isPaginationShow="false"
        ref="tableForm"
      />
      <br/><br/>
      <el-button @click="updateSplittable()">保存</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import RepayForApproval from "../components/RepayForApproval";
  import {formatMoney} from "../../filters/CommonFilters";
  import constant from "../../utils/constant";
/*  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";*/


    export default {
        name: "TransferRepaymentList",
      components: {RepayForApproval},
      data(){
        return{
          showSelect:true,
          repayDate:'',
          selectType:'',
          split:'',
          radio:'',
          radioType:'',
          balanceAmount:0,
          repayBool:true,
          tableDataMatching:{
            count: 0,
            data: []
          },
          queryData:'',
          txDate:'',
          remarks:'',
          bankDetail:{},
          bankColumns:[
            {
              label: '银行流水',
              field: 'de__bankRef',
              span:24
            },
            {
              label: '对方账户名',
              field: 'de__txAccountName',
              span:24
            },
            {
              label: '对方账号',
              field: 'de__txAccountNo',
              span:24
            },
            {
              label: '对方银行',
              field: 'de__txBankName',
              span:24
            },
            {
              label: '交易金额',
              field: 'de__creditAmount',
              span:24
            },
            {
              label: '转账备注',
              field: 'de__txUse',
              span:24
            },
          ],
          columnsMatching:[
            {
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              label: '客户姓名',
              field: 'c__customerName'
            },
            {
              label: '贷款开始时间',
              field: 'fi__startDate'
            },
            {
              label: '贷款结束时间',
              field: 'fi__endDate'
            },
            {
              label: '贷款金额',
              field: 'fi__totalAmount'
            },
            {
              label: '期数',
              field: 'plan__sequenceNo'
            },
            {
              label: '还款日期',
              field: 'plan__repayDate'
            },
            {
              label: '还款金额',
              field: 'plan__repayAmount'
            },
            {
              label: '本金',
              field: 'plan__principalAmount'
            },
            {
              label: '利息',
              field: 'plan__interestAmount'
            },
            {
              label: '服务费',
              field: 'plan__lendingFeeAmount'
            },
            {
              label: '操作',
              opts:[
                {
                  label: '选择',
                  class: 'el-icon-finished',
                  clickHandler: (index, row)=> {
                    this.updateOutstanding(row.plan__entryId)
                  }
                },
              ]
            }
          ],
          pageMatching: 1,
          pageSizeMatching: 20,
          actionsMatching: [
          ],

          filtersMatching: {
            labelWidth: '150px',
            form: {
              dt__deviceType:'',
            },
            columns: [
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'c__customerName'
              },
              {
                label: '手机号',
                component: 'el-input',
                field: 'c__customerContactNo'
              },
              {
                label: '还款日期',
                component: 'date-range-picker',
                field: 'plan__repayDate',
                op: ['gteq', 'lteq'],
                span: 14
              },

            ],
            onSubmit:()=>{
              this.pageMatching = 1
              this.getDataMatching()
            }
          },

          detailArray: [],
          selectedIds: '',
          bankStatus:'Processing',
          dialogVisible2:false,
          dialogVisible3:false,
          dialogVisible4:false,
          dialogVisible5:false,
          dialogVisible6:false,
          detailId:'',
          detailIdNotes:'',
          splittableDatacolumns:[
            {
              label: '序号',
              type: 'index'
            },
            {
              label: '子流水号',
              field: 'dx__No',
            },
            {
              label: '转账金额',
              field: 'dx__creditAmount',
              component: 'el-input',
              type: 'number',
              rules: [
                {
                  required: true,
                  message: '转账金额不能为空',
                  trigger: 'blur'
                },
              ]
            },
          ],
          columns:[
            {
              type: 'index'
            },
            {
              label: '收款记录',
              field: 'de__detailId',
              component: (r,c,v) => {
               // console.log(r.de__txBankName)
                var bankName = (r.de__txBankName || '').split("银行")[0]+'银行'
                var supportedBanks = ['上海浦东发展银行','中信银行','中国光大银行','中国农业银行','中国工商银行','中国建设银行','中国邮政储蓄银行','中国银行','兴业银行','华夏银行',
                '招商银行','平安银行','广发银行','无锡农村商业银行','江苏江阴农村商业银行','江苏银行','交通银行']
                var bool = false
                let bankLogos = {
                  default: require('../../assets/images/bank/bank.png')
                }
                supportedBanks.forEach(item=>{
                  bankLogos[item] = require('../../assets/images/bank/'+ item +'.png')
                  if(bankName==item){
                    bool =true
                  }
                })

                // if(bool){
                //   bankName = bankName+'.png'
                // }else{
                //   bankName = 'bank.png'
                // }
                var handleClickRepay = this.handleClickRepay
                var editRemarks = this.editRemarks
                var updateBank = this.updateBank
                var splittableUpdate = this.splittableUpdate
                var getSplittable = this.getSplittable
                var txDate = moment(r.de__txDate).format('YYYY-MM-DD HH:mm:ss')
                var txAccountName =  r.de__txAccountName
                var customerId = ''
                var splitted = r.de__splitted
                var splittable = ''
                const details = this.detailArray.filter(item=>item.de__detailId == r.de__detailId)
                let boolname = true
                let detailsNum = false
                let transactionId = null
                var customerName = null
                if(details.length>0){
                  detailsNum = true
                }
                details.forEach(detail=> {
                  splittable = detail.de__splittable
                  if(transactionId==null){
                    transactionId = detail.fi__transactionId
                  }else{
                    if(transactionId!=detail.fi__transactionId){
                      detailsNum = false
                    }
                  }

                  if(customerName){
                      if(customerName!=detail.fi__customerName){
                        boolname= false
                      }
                  }else{
                    customerName = detail.fi__customerName
                    customerId  = detail.fi__customerId
                  }
                })
                if(boolname){
                  if(txAccountName==customerName){

                  }else{
                    boolname = false
                  }
                }

                var html = `<div class="tl ">

                  <div class="mesg_rgjrbr" @dblclick=" ${detailsNum}&&updateBank('${r.de__detailId}', '${customerId}',${boolname},'${transactionId}')">${r.de__txAccountName|| '' }&nbsp;<img :src="supportedBanks.includes('${bankName}') ? bankLogos.${bankName} : bankLogos.default" alt="" style="width: 20px;height:20px">&nbsp;${r.de__txAccountNo||''}&nbsp;<span v-if="boolname" class="tale_person">本人 </span></div>
                  <div>
                    转账时间：${txDate}&nbsp; 转账${r.de__currencyName}：
                    <a href="javascript:void(0)" @click="handleClickRepay('`+ r.de__detailId +`')" style="white-space: nowrap;">${r.de__creditAmount}</a>
                    <a v-if="splittable=='true'&&splitted=='N'" class="EditSplit" @click="getSplittable('${r.de__detailId}')" title="拆分"></a>
                    <a v-if="splitted=='Y'" class="EditRecovery" @click="splittableUpdate('${r.de__detailId}')" title="恢复"></a>
                    <!--<el-button class="LookMesg" ></el-button>-->
                  </div>
                  <div>转账备注：${r.de__txUse?r.de__txUse:''}</div>
                  <div class="mesg_rgbz">人工备注：${r.de__notes ? r.de__notes : ''}<el-button class="EditMesg fr" @click="editRemarks('`+ r.de__detailId +`')" ></el-button></el-button></div>
                  </div>`

                return {
                  template: html,
                  data() {
                    return {
                      bankLogos,
                      supportedBanks,
                      boolname,
                      detailsNum,
                      transactionId,
                      splitted,
                      splittable,
                    }
                  },
                  methods: {
                    handleClickRepay,
                    editRemarks,
                    updateBank,
                    splittableUpdate,
                    getSplittable
                  }
                }
              }
            },
            {
              label: '贷款匹配',
              field: 'de__detailId',
              component: (r,c,v)=> {
                const details = this.detailArray.filter(item=>item.de__detailId == v)
                const htmls = []
                const repaymentEdit = this.repaymentEdit
                const deleteResolve = this.deleteResolve
                details.forEach((detail, idx)=> {
                  if(r.de__status=='Processing') {
                    var html = `<div class="tl hkjl_list">

                    <div class="hkhetong">${detail.fi__contractNo} &nbsp;&nbsp;&nbsp; ${detail.fi__customerName}</div>
                    <div class="hkmesg"><span>应还款日：${detail.plan__repayDate} 期数(${detail.plan__sequenceNo}/${detail.fi__repaymentCount})</span> <span><el-tooltip>
                    <div slot="content"><div class="tool-tips-text">应还金额=本期应还本金+本期应还利息+复利+罚息-上次还款余额</div><div><table class="tool-tips-table">
                    <thead><tr>
                    <th>应还金额</th>
                    <th>本期应还本金</th>
                    <th>本期应还利息</th>
                    <th>复利</th>
                    <th>罚息</th>
                    <th>上次还款余额</th>
                    </tr></thead><tbody><tr>
                    <td>${detail.plan__appliedRepayAmount}</td>
                    <td>${detail.plan__expectedPrincipalAmount}</td>
                    <td>${detail.plan__expectedInterestAmount}</td>
                    <td>${detail.plan__expectedCompoundInterest}</td>
                    <td>${detail.plan__expectedOverdueFine}</td>
                    <td>${detail.plan__exBalanceAmount}</td>
                    <!--<td class="color-danger"></td>-->
                    </tr></tbody>
                    </table></div></div>
                      <el-button class="hkjl_tool_tips">应还：${detail.plan__expectedRepayAmount}</el-button>
                    </el-tooltip></span> <span>实还：${detail.plan__appliedRepayAmount}</span></div>

                      <div class="table_txt">
                         <!-- <i></i>
                          <ul class="table_show of">
                              <li class="on">指定用户还款</li>
                              <li class="on">曾用非指定还款</li>
                              <li class="on">合同号</li>
                          </ul>-->
                          <div v-if="details[${idx}].plan__overdueDays>0 && (details[${idx}].plan__overdueDays <= ${this.gracePeriod}) " class="color-warning">逾期 &nbsp;${detail.plan__overdueDays}&nbsp;天</div>
                          <div v-if="details[${idx}].plan__overdueDays>0 && (details[${idx}].plan__overdueDays > ${this.gracePeriod}) " class="color-danger">逾期 &nbsp;${detail.plan__overdueDays}&nbsp;天</div>


                      </div>
                      <div  style="color:#0000ff" v-if="details[${idx}].plan__applicable=='false'" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;还款审核中</div>
                      <el-button v-if="r.de__status=='Processing'" class="hkjl_del" @click="deleteResolve('` + detail.re__resolveId + `')"></el-button>

                      <div class="cb"></div>
                    </div>`

                    htmls.push(html)
                  } else if (this.bankStatus == 'Settled'){
                    var html = `<div class="tl hkjl_list">

                    <div class="hkhetong">${detail.fi__contractNo} &nbsp;&nbsp;&nbsp; ${detail.fi__customerName}</div>
                    <div class="hkmesg"><span>实还款日：${detail.re__repayDate} 期数(${detail.plan__sequenceNo}/${detail.fi__repaymentCount})</span> <!-- <span><el-tooltip>
                    <div slot="content"><div class="tool-tips-text">应还金额=本期应还本金+本期应还利息+复利+罚息-上次还款余额</div><div><table class="tool-tips-table">
                    <thead><tr>
                    <th>应还金额</th>
                    <th>本期应还本金</th>
                    <th>本期应还利息</th>
                    <th>复利</th>
                    <th>罚息</th>
                    <th>上次还款余额</th>
                    </tr></thead><tbody><tr>
                    <td>${detail.plan__appliedRepayAmount}</td>
                    <td>${detail.plan__expectedPrincipalAmount}</td>
                    <td>${detail.plan__expectedInterestAmount}</td>
                    <td>${detail.plan__expectedCompoundInterest}</td>
                    <td>${detail.plan__expectedOverdueFine}</td>
                    <td>${detail.plan__exBalanceAmount}</td>
                    <td class="color-danger"></td>
                    </tr></tbody>
                    </table></div></div>
                      <el-button class="hkjl_tool_tips">应还：${detail.plan__expectedRepayAmount}</el-button>
                    </el-tooltip></span> --><br/>
                      <span>应还本金：${detail.re__expectedPrincipalAmount}</span>
                      <span>应还利息：${detail.re__expectedInterestAmount}</span>
                      <span>应还复利：${detail.re__expectedCompoundInterest}</span>
                      <span>应还罚息：${detail.re__expectedOverdueFine}</span><br/>

                      <span>实收本金：${detail.re__principalAmount}</span>
                      <span>实收利息：${detail.re__interestAmount}</span>
                      <span>减免：${detail.re__deductionAmount}</span>
                    </div>
                    <div style="color:#0000ff" v-if="details[${idx}].re__principalAmount == details[${idx}].re__expectedPrincipalAmount && details[${idx}].re__interestAmount == details[${idx}].re__expectedInterestAmount">（本期已还清）</div>


                      <div class="table_txt">
                         <!-- <i></i>
                          <ul class="table_show of">
                              <li class="on">指定用户还款</li>
                              <li class="on">曾用非指定还款</li>
                              <li class="on">合同号</li>
                          </ul>-->
                          <div v-if="details[${idx}].plan__overdueDays>0 && (details[${idx}].plan__overdueDays <= ${this.gracePeriod}) " class="color-warning">逾期 &nbsp;${detail.plan__overdueDays}&nbsp;天</div>
                          <div v-if="details[${idx}].plan__overdueDays>0 && (details[${idx}].plan__overdueDays > ${this.gracePeriod}) " class="color-danger">逾期 &nbsp;${detail.plan__overdueDays}&nbsp;天</div>

                      </div>
                      <el-button v-if="r.de__status=='Processing'" class="hkjl_del" @click="deleteResolve('` + detail.re__resolveId + `')"></el-button>

                      <div class="cb"></div>
                    </div>`

                    htmls.push(html)

                  }
                })

                return {
                  template: '<div>' + htmls.join('') + '</div>',
                  data() {
                    return {
                      r,
                      htmls,
                      details,
                      gracePeriod: this.gracePeriod
                    }
                  },
                  methods: {
                    repaymentEdit,
                    deleteResolve
                  }
                }
              }
            },
            {
              label: '操作',
              width: '180',
              conditions: ()=> this.bankStatus == 'Processing',
              opts:[
                {
                  label: '选择匹配',
                  class: 'el-icon-finished',
                  clickHandler: (index, row)=> {
                    this.dialogVisible3 = true
                    this.detailId = row.de__detailId
                    this.tableDataMatching = {
                      count: 0,
                        data: []
                    }
                    this.filtersMatching={
                      labelWidth: '150px',
                      form: {
                        dt__deviceType:'',
                      },
                      columns: [
                        {
                          label: '客户姓名',
                          component: 'el-input',
                          field: 'c__customerName'
                        },
                        {
                          label: '手机号',
                          component: 'el-input',
                          field: 'c__customerContactNo'
                        },
                        {
                          label: '还款日期',
                          component: 'date-range-picker',
                          field: 'plan__repayDate',
                          op: ['gteq', 'lteq'],
                          span: 14
                        },

                      ],
                      onSubmit:()=>{
                        this.pageMatching = 1
                        this.getDataMatching()
                      }
                    }
                    this.getDataMatching()
                    /*this.$router.push(
                      {
                        path: 'OutstandingList',
                        query: {
                          detailId: row.de__detailId
                        }
                      }
                    )*/
                  },
                  conditions: row=> {
                    return row.de__status=='Processing'

                  }
                },
                {
                  label: '还款申请',
                  class: 'el-icon-huankuan',
                  clickHandler: (index, row)=> {
                    const details = this.detailArray.filter(item=>item.de__detailId == row.de__detailId)
                    const resolveIds = []
                    details.forEach(detail=> {
                      resolveIds.push(detail.re__resolveId)
                    })
                    this.selectType = 'one'
                    this.repayDate = details[0].plan__repayDate
                    this.repaymentEdit(resolveIds.join(','))

                  },
                  conditions: row=> {
                    const details = this.detailArray.filter(item=>item.de__detailId == row.de__detailId)

                    let applicable = 'false'
                    details.forEach(detail=> {
                      applicable = detail.plan__applicable
                    })

                    return applicable=='true'&&row.de__status=='Processing'

                  }
                },
                {
                  label: '确认匹配',
                  class: 'el-icon-check',
                  clickHandler: (index, row)=> {
                    let  resolveIds = []
                    const details = this.detailArray.filter(item=>item.de__detailId ==  row.de__detailId)
                    details.forEach(detail=> {
                      resolveIds.push(detail.re__resolveId)
                    })
                    this.selectedIds = resolveIds.join(',')
                    this.repayDate = details[0].plan__repayDate
                    this.selectType = 'two'

                    this.BatchUpdate()
                  },
                  conditions: row=> {
                    const details = this.detailArray.filter(item=>item.de__detailId == row.de__detailId)
                    let transactionId = ''
                    let repayBool = true
                    details.forEach(detail=> {
                      if(transactionId==''){
                        transactionId = detail.fi__transactionId
                      }else{
                        if(repayBool){
                          if(transactionId!=detail.fi__transactionId){
                            repayBool = false
                          }
                        }
                      }
                    })

                      let statusDate = true
                      if(details.length==0){
                          statusDate = false
                      }
                      details.forEach(detail=> {
                          if(detail.plan__statusDate=='false'){
                              statusDate = false
                          }
                      })
                    return row.de__status=='Processing'&&repayBool&&details.length>0&&!statusDate

                  }
                },
                  {
                      label: '宕账',
                      class: 'el-icon-s-cooperation',
                      clickHandler: (index, row)=> {
                          let  resolveIds = []
                          const details = this.detailArray.filter(item=>item.de__detailId ==  row.de__detailId)
                          details.forEach(detail=> {
                              resolveIds.push(detail.re__resolveId)
                          })

                          this.RepayNext(resolveIds.join(','))
                      },
                      conditions: row=> {
                          const details = this.detailArray.filter(item=>item.de__detailId == row.de__detailId)
                          let transactionId = ''
                          let repayBool = true
                          details.forEach(detail=> {
                              if(transactionId==''){
                                  transactionId = detail.fi__transactionId
                              }else{
                                  if(repayBool){
                                      if(transactionId!=detail.fi__transactionId){
                                          repayBool = false
                                      }
                                  }
                              }
                          })

                          let statusDate = true
                          if(details.length==0){
                              statusDate = false
                          }
                          details.forEach(detail=> {
                                if(detail.plan__statusDate=='false'){
                                    statusDate = false
                                }
                          })
                          return statusDate&&row.de__status=='Processing'&&repayBool&&details.length>0

                      }
                  },

                {
                  label: '其他业务',
                  class: 'el-icon-error',
                  clickHandler: (index, row)=> {
                    this.deleteData(row.de__detailId)
                  },
                  conditions: row=> {
                    return row.de__status=='Processing'

                  }
                },
              ]
            }
          ],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
         /*   {
              label: '确认匹配',
              class: 'el-button--primary',
              clickHandler: ()=>{
                if(this.queryData==''){
                  this.$message.error('请选择一条数据')
                  return false
                }
                let resolveId = true
                this.queryData.split(',').forEach(items=>{
                  const details = this.detailArray.filter(item=>item.de__detailId == items)
                  if(details.length==0){
                    resolveId =  false
                  }
                    this.repayDate = details[0].plan__repayDate
                })
                if(!resolveId){
                  this.$message.error('存在未匹配贷款的数据')
                  return false
                }
                this.selectType = 'two'

                this.BatchUpdate()
              },
              conditions: ()=> this.bankStatus == 'Processing'
            },*/
            {
              label: '提前还款',
              class: 'el-button--primary',
              clickHandler: ()=>{
                if(this.queryData==''){
                  this.$message.error('请选择一条数据')
                  return false
                }
                if(!this.repayBool){
                  this.$message.error('选择记录匹配了不同的贷款，请保持所选记录匹配的贷款一致')
                  return false
                }
                let resolveId = true
                this.queryData.split(',').forEach(items=>{
                  const details = this.detailArray.filter(item=>item.de__detailId == items)
                  if(details.length==0){

                    resolveId =  false
                  }
                })
                if(!resolveId){
                  this.$message.error('存在未匹配贷款的数据')
                  return false
                }
                this.$router.push(
                  {
                    path: 'Edit',
                    query: {
                      resolveIds:this.selectedIds,
                      //queryData:this.queryData,
                      txDate : this.txDate
                    }
                  }
                )
              },
              conditions: ()=> this.bankStatus == 'Processing'
            }
          ],
          filters: {
            labelWidth: '150px',
            form: {
              de__txAccountName:'',
              de__txDate:[],
            },
            columns: [
              {
                label: '对方账户名',
                component: 'el-input',
                field: 'de__txAccountName'
              },
              {
                label: '转账时间',
                component: 'date-range-picker',
                field: 'de__txDate',
                op: ['gteq', 'lteq'],
                dateFormat: ['yyyy-MM-dd 00:00:00','yyyy-MM-dd 23:59:59'],
                span: 12
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },
          dialogVisible: false,
          repayForApprovalDialogVisible: false,
          repayInfo: {
            data: []
          },
          splittableData: {
            detail: [
            ]
          },
          gracePeriod:0,
        }
      },
      mounted() {
        this.getData()

      },

      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
          }
        },
        filterParamsMatching() {
          return {
            pageSize: this.pageSizeMatching,
            pageOffset: (this.pageMatching - 1) * this.pageSizeMatching,
          }
        },

        watchLastCreditAmount() {
          return this.splittableData.detail.reduce( (total, curr, idx) => {
            if(idx != this.splittableData.detail.length -1 ) {
              total += Number(curr.dx__creditAmount)||0
            }
            return total
          }, 0)
        }
      },
      watch: {
        watchLastCreditAmount: function (newVal, oldVal) {

          let creditAmount = 0
          this.splittableData.detail.forEach((item,idx)=>{
            if(idx!=(this.splittableData.detail.length -1)){
              creditAmount = creditAmount + Number(item.dx__creditAmount)
            }

          })
          this.splittableData.detail[this.splittableData.detail.length -1].dx__creditAmount =(Number(this.splittableData.de__creditAmount) -creditAmount)>0?(Number(this.splittableData.de__creditAmount) -creditAmount).toFixed(2):0
        },
        filterParams: function (newVal) {
          this.getData()
        },
        filterParamsMatching: function (newVal) {
          this.getDataMatching()
        },
        'bankStatus':function () {
          this.tableData = {
            count: 0,
            data: []
          }
          this.detailArray = []
          this.getData()
        },
      },
      methods: {
        getDataMatching: function () {
          xhr.getOutstandingList(
            Object.assign({}, this.filterParamsMatching, xmlBuildQuery(this.filtersMatching)),
            res=> {
              try {
                this.tableDataMatching = res.data
              }catch(e){

              }
            })

        },
        getData: function () {
          if(this.bankStatus=='Processing'){
            xhr.getResolvingBankStatementList(
              Object.assign({
                  'xlist.sort.dataField': 'de.txDate',
                  'xlist.sort.order': 'asc'
              }, this.filterParams, xmlBuildQuery(this.filters)),
              res=> {
                try {
                  this.tableData = res.data
                  const detailIds = res.data.data.map(item=>item.de__detailId).join(',')

                  xhr.getResolvingBankStatementDetailList(
                    Object.assign({
                      details:detailIds,
                      pageSize:0,
                    },{}, {}),
                    res=> {
                      try {
                        this.detailArray = res.data.data||[]
                        this.gracePeriod = res.data.variables.gracePeriod

                      }catch(e){

                      }
                    })


                }catch(e){
                  console.log(e)

                }
              })
          }
          if(this.bankStatus=='Settled'){
            xhr.getSettledBankStatementList(
              Object.assign({
                  'xlist.sort.dataField': 'de.txDate',
                  'xlist.sort.order': 'desc'
              }, this.filterParams, xmlBuildQuery(this.filters)),
              res=> {
                try {
                  this.tableData = res.data
                  const detailIds = res.data.data.map(item=>item.de__detailId).join(',')

                  xhr.getSettledBankStatementDetailList(
                    Object.assign({
                      details:detailIds,
                      pageSize:0,
                    },{}, {}),
                    res=> {
                      try {
                        this.detailArray = res.data.data||[]


                      }catch(e){

                      }
                    })


                }catch(e){
                  console.log(e)

                }
              })
          }

        },
        repaymentEdit: function (resolveId) {
          xhr.getRepayInfo(
            {
              'de.candidates': resolveId
            },
            res => {
              if(res.data.status == 'success') {
                const repayInfo = res.data.data || {}
                repayInfo.detail.forEach(item => {
                  item.rex__expectedCompoundInterestChecked = 'N'
                  item.rex__expectedOverdueFineChecked = 'N'
                })
                  repayInfo.detail = repayInfo.detail.filter(n => n['plan__sequenceNo'])

                this.repayInfo = repayInfo
                this.repayForApprovalDialogVisible = true
              }else{
                this.$message.error(res.data.msgs[0].text)
              }
            }
          )
        },
        deleteResolve:function(resolveId){
          xhr.deleteVoidResolve(
            {resolveId:resolveId
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.getData()
                }else{

                  this.$message.error(res.data.msgs[0].text)
                }

              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        },
        deleteData:function(detailId) {
          this.$confirm("是否确定忽略该数据？").then(()=> {
            xhr.deleteVoidBankStatementDetail(
              {
                detailId: detailId
              },
              res => {
                try {
                  if (res.data.status == 'success') {
                    this.getData()
                  } else {

                    this.$message.error(res.data.msgs[0].text)
                  }

                } catch (e) {

                  this.$message.error(error.msgs[0].text)

                }
              }
            )
          })
          .catch(()=> {

          })
        },

        handleClickRepay: function (detailId) {
          /*const detail =
          console.log(bankDetail)*/
          this.dialogVisible = true
          this.bankDetail = this.tableData.data.filter(item=>item.de__detailId == detailId)[0]
           console.log(this.bankDetail)
        },
        updateBank:function(detailId,customerId,boolname,transactionId){
          if(boolname){
            this.$confirm("是否确定将转账信息加入本人账户信息表？").then(()=> {
              let bankDetail = this.tableData.data.filter(item => item.de__detailId == detailId)[0]

              xhr.updateBank(
                {
                  c__customerId:customerId,
                  cb__accountId:'',
                  cb__accountNo: bankDetail.de__txAccountNo,
                  cb__accountName: bankDetail.de__txAccountName,
                  cb__bank: bankDetail.de__txBankName,
                  c__checked:true
                },
                res=>{
                  try {
                    if(res.data.status == 'success') {
                      /*this.$message({
                        type: 'success',
                        message: '保存成功！'
                      })*/
                    }
                    else {
                      this.$message.error(error.msgs[0].text)
                    }
                  }catch (e) {
                    this.$message.error(error.msgs[0].text)
                  }
                })
            })
              .catch(()=> {

              })
          }else{
            this.$confirm("是否确认将共借人转账信息加入账户信息表？").then(()=> {
              let bankDetail = this.tableData.data.filter(item => item.de__detailId == detailId)[0]

              xhr.updateBank2(
                {
                  cb__accountId:'',
                  cb__accountNo: bankDetail.de__txAccountNo,
                  cb__accountName: bankDetail.de__txAccountName,
                  cb__bank: bankDetail.de__txBankName,
                  fi__transactionId:transactionId,
                },
                res=>{
                  try {
                    if(res.data.status == 'success') {
                      /*this.$message({
                        type: 'success',
                        message: '保存成功！'
                      })*/
                    }
                    else {
                      this.$message.error(error.msgs[0].text)
                    }
                  }catch (e) {
                    this.$message.error(error.msgs[0].text)
                  }
                })
            })
              .catch(()=> {

              })
          }



        },
        editRemarks: function (detailId) {
          this.dialogVisible4 = true
          this.detailIdNotes = detailId
          xhr.getAddNotes(
            {
              detailId: detailId
            },
            res => {
              try {
                if (res.data.status == 'success') {
                  this.remarks = res.data.data.de__notes
                } else {

                  this.$message.error(res.data.msgs[0].text)
                }

              } catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        },
        updateApproveRepayment:function(){
          xhr.updateAddNotes(
            {
              detailId: this.detailIdNotes,
              notes :this.remarks
            },
            res => {
              try {
                if (res.data.status == 'success') {
                  this.remarks = ''
                  this.detailIdNotes = ''
                  this.dialogVisible4 = false
                  this.getData()
                } else {

                  this.$message.error(res.data.msgs[0].text)
                }

              } catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        },
        handleSelectChange: function (val) {
          let   selectedIds = val.map(item=>item.de__detailId)
          this.repayBool = true
          this.queryData = selectedIds.join(',')
          this.txDate = val.map(item=>item.de__txDate)[0]

          let  resolveIds = []
          let transactionId = ''
          selectedIds.forEach(items=> {
            const details = this.detailArray.filter(item=>item.de__detailId == items)
            console.log(details)

            details.forEach(detail=> {
              resolveIds.push(detail.re__resolveId)
              if(transactionId==''){
                transactionId = detail.fi__transactionId
              }else{
                if(this.repayBool){
                  if(transactionId!=detail.fi__transactionId){
                    this.repayBool = false
                  }
                }
              }
            })
          })

          this.selectedIds = resolveIds.join(',')
          /*this.count = 0
          this.result = false
          for(var i=0;i<val.length;i++){
            if(val[i].report__serviceStatus!='Processing'){
              this.result = true
              this.count++
            }
          }*/
          /*if(result){
            this.$message.error('存在'+count+'条数据不符合条件')
          }*/
        },


          RepayNext:function(resolveIds){
              let form = {
                  resolveId:resolveIds
              }
              xhr.RepayNext(
                  form,
                  res=> {
                      try{
                          if(res.data.status == 'success') {
                              this.getData()
                          }else{

                              this.$message.error(res.data.msgs[0].text)
                          }

                      }catch (e) {

                          this.$message.error(error.msgs[0].text)

                      }
                  }
              )

          },
        BatchUpdate:function () {
          let form = {
            candidates:this.selectedIds
          }
          if(this.split=='no'){
            form.t__excessAmountOption =  this.radioType
            form.split =  'no'
          }
          xhr.updateRepayInBatch(
            form,
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.getData()
                  this.selectedIds = ''
                  this.split = ''
                  this.radio = ''
                  this.radioType= ''
                  this.dialogVisible5=false
                }else{

                  if(res.data.errdata.splittable){
                    if(res.data.errdata.balanceAmount>0){
                      this.balanceAmount = res.data.errdata.balanceAmount
                      this.dialogVisible5=true
                      this.showSelect = false
                    }
                  }
                }

              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        },
        updateOutstanding:function (entryId) {
          this.$confirm("是否确定选择？").then(()=>{
            xhr.updateOutstanding(
              {
                entryId:entryId,
                detailId:this.detailId,
                resolve__checked:true
              },
              res=> {
                try{
                  if(res.data.status == 'success') {
                   this.getData()
                    this.dialogVisible3 = false
                  }else{

                    this.$message.error(res.data.msgs[0].text)
                  }
                }catch (e) {

                  this.$message.error(error.msgs[0].text)

                }
              }
            )
          })
          .catch(()=> {

          })
        },
        handleRepayForApproval: function () {

          let form = {
            detail:[]
          }
          let next = true
          if(this.split=='no'){
            form.t__excessAmountOption =  this.radioType
            form.split =  'no'
          }
          console.log(this.repayInfo)
          this.repayInfo.detail.forEach(item=> {
            let mm = {}
            mm.rex__exBalanceAmount = item.rex__exBalanceAmount
            mm.rex__appliedOverdueFine = item.rex__appliedOverdueFine
            mm.rex__appliedCompoundInterest = item.rex__appliedCompoundInterest

            mm.rex__appliedInterestAmount = item.rex__appliedInterestAmount
            mm.rex__appliedPrincipalAmount = item.rex__appliedPrincipalAmount
            mm.rex__excessAmount = item.rex__excessAmount
            mm.plan__entryId = item.plan__entryId

            mm.rex__waiveCompoundInterest = item.rex__waiveCompoundInterest
            mm.rex__waiveOverdueFine = item.rex__waiveOverdueFine
            mm.rex__extendingDays = item.rex__extendingDays||0
            mm.rex__extendingInterestAmount = item.rex__extendingInterestAmount||0
            if(parseFloat(item.rex__extendingDays)>parseFloat(this.repayInfo.t__gracePeriod)&&item.rex__extendible=='Y'){

              next = false
            }
            form.detail.push(mm)
          })
          form.de__candidates = this.repayInfo.de__candidates
          form.t__remarks = this.repayInfo.t__remarks

          if(!next){
            this.$alert('延期天数不能大于'+this.repayInfo.t__gracePeriod)
            return false
          }
          xhr.updateRepayForApproval(
            form,
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.split = ''
                  this.radio = ''
                  this.radioType= ''
                  this.getData()
                  this.dialogVisible5=false
                  this.repayForApprovalDialogVisible= false
                }else{
                  if(res.data.errdata.splittable){
                    if(res.data.errdata.balanceAmount>0){
                      this.balanceAmount = res.data.errdata.balanceAmount
                      this.dialogVisible5=true
                      this.showSelect = true
                    }
                  }
                }

              }catch (e) {

                this.$message.error(e.msgs[0].text)

              }
            }
          )

        },
        updateApproveSelect:function () {
          if(this.radio=='N'){
            this.dialogVisible5=false
            this.repayForApprovalDialogVisible = false
            this.radio = ''
          }else if(this.radio=='Y'){
              if(this.radioType!=''||!this.showSelect){
                this.split = 'no'
                if(this.selectType=='one'){

                  this.handleRepayForApproval()
                }
                if(this.selectType=='two'){

                  this.BatchUpdate()
                }

              }else{
                this.$message.error('请选择处理方式种类')
              }
          }else{
            this.$message.error('请选择处理方式')
          }
        },
        getSplittable:function (detailId) {
          xhr.getSplittable(
            {
              detailId: detailId
            },
            res => {
              try {
                if (res.data.status == 'success') {
                  let tmpArr = res.data.data
                  let count = 1
                  tmpArr.detail.forEach(item=>{
                    item.dx__No = tmpArr.de__bankRef+'-'+count
                    item.dx__creditAmount = 0
                    count++
                  })
                  this.splittableData = tmpArr
                  this.dialogVisible6=true
                } else {

                  this.$message.error(res.data.msgs[0].text)
                }

              } catch (e) {

              }
            }
          )
        },
        updateSplittable:function(){
          let amount = 0
          let form = {
            detail:[]
          }
          form.detailId = this.splittableData.de__detailId

          this.splittableData.detail.forEach(item=>{
            if(item.dx__creditAmount){
              amount = amount +(Number(item.dx__creditAmount)||0)*100
              let mm = {}
              mm.fi__transactionId = item.fi__transactionId
              mm.dx__creditAmount = item.dx__creditAmount
              form.detail.push(mm)
            }
          })
          if((Number(this.splittableData.de__creditAmount)||0).toFixed(2)==(amount/100).toFixed(2)){
            xhr.updateSplittable(
              form,
              res=> {
                try{
                  if(res.data.status == 'success') {

                    this.getData()
                    this.dialogVisible6=false

                  }else{

                  }
                }catch (e) {

                  this.$message.error(e.msgs[0].text)

                }
              }
            )
          }else{
            this.$message.error('拆分金额合计与转账金额不等')
          }
        },
        splittableUpdate:function (detailId) {
          let returnMsgList = ['确认要恢复到原流水？','一旦恢复到原流水则需要将其他拆分出来的自留水一并清除'
        ]
          let newDatas = [],h = this.$createElement;
          for (const i in returnMsgList) {
            newDatas.push(h('p', null, returnMsgList[i]))
          }
          this.$confirm(h('div', null, newDatas)).then(()=>{
          xhr.splittableUpdate(
            {
              'detailId':detailId,
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.getData()
                }else{

                }
              }catch (e) {

                this.$message.error(e.msgs[0].text)

              }
            }
          )
          })
            .catch(()=> {

            })
        },
      dataRelaod:function () {
          this.selectedIds = ''
          this.split = ''
          this.radio = ''
          this.radioType= ''
      },
    }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/TransferRepaymentList.vue